import React, { createContext } from 'react';
import useCreateClient from "./useCreateClient.js";
import { jsx as _jsx } from "react/jsx-runtime";
export var ClientContext = /*#__PURE__*/createContext(null);
ClientContext.displayName = 'ClientContext';
/**
 * ClientBootstrap component. Handles creating the client.
 */
export function ClientBootstrap(_ref) {
  var serverUrl = _ref.serverUrl,
    options = _ref.options,
    children = _ref.children;
  var client = useCreateClient(serverUrl, options);
  return /*#__PURE__*/_jsx(ClientContext.Provider, {
    value: client,
    children: children
  });
}
export default ClientBootstrap;
//# sourceMappingURL=ClientBootstrap.js.map